import { type FC, type ReactElement, useMemo } from "react";

import { AuthOperation, type Permissions } from "../../gql-generated/aliases";
import { useSelectedOrganization } from "../../organizations/hooks";
import type { Maybe } from "../../../gql-generated/types";

interface AccessContainerProps {
    children: (api: { permissions: Permissions; orgAppAuth: readonly Maybe<string>[] }) => ReactElement;
}

export const AccessContainer: FC<AccessContainerProps> = ({ children }) => {
    const { permissions, orgAuthorizedOperations } = useSelectedOrganization();

    const authOpSnapKitApps = AuthOperation.AuthOperationSnapKitApps;

    const orgAppAuth: readonly Maybe<string>[] = useMemo(
        () => orgAuthorizedOperations?.find((op) => op.authOperation === authOpSnapKitApps)?.authOperationTypes || [],
        [authOpSnapKitApps, orgAuthorizedOperations],
    );

    return children({ permissions, orgAppAuth });
};
